import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { FloatingButton } from '../Ui';
import { Link } from 'react-router';

import {
	LOCKING_FORM_MODES,
	getLockingForm,
	doOpenLockingForm
} from '../reducers/app/lockingForm';

import { newLocking, newGroup } from './lockings/lockingsActions';

class LockingsButton extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isDropdownOpen: false
		};
		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.handleBtnClick = this.handleBtnClick.bind(this);
		this.handleNewLockingClick = this.handleNewLockingClick.bind(this);
		this.handleNewGroupClick = this.handleNewGroupClick.bind(this);
		this.openDropdown = this.openDropdown.bind(this);
		this.closeDropdown = this.closeDropdown.bind(this);
	}

	componentDidMount() {
		addEventListener('click', this.handleClickOutside);
	}

	componentWillUnmount() {
		removeEventListener('click', this.handleClickOutside);
	}

	render() {
		const btnClasses = classNames({
			'c-lockings-btn': true,
			'is-active': this.state.isDropdownOpen,
			'is-disabled': this.props.isOpen
		});

		const dropdownClasses = classNames({
			'c-lockings-btn__dropdown': true,
			'is-active': this.state.isDropdownOpen
		});

		return (
			<div>
				<FloatingButton iconName="add" onClick={this.handleBtnClick} />
				<ul className={dropdownClasses}>
					<li
						className="c-lockings-btn__item"
						onClick={this.handleNewLockingClick}
					>
						Nouvelle ouverture
					</li>
					<li
						className="c-lockings-btn__item"
						onClick={this.handleNewGroupClick}
					>
						Nouveau groupe
					</li>
					<Link
						className="c-lockings-btn__link"
						to={
							'/app/project/' +
							encodeURIComponent(this.props.projectId) +
							'/pattern-duplication'
						}
					>
						<li className="c-lockings-btn__item">Nouveau motif</li>
					</Link>
				</ul>
			</div>
		);
	}

	handleClickOutside(event) {
		let domNode = ReactDOM.findDOMNode(this);
		if (!domNode.contains(event.target)) {
			this.closeDropdown();
		}
	}

	handleBtnClick() {
		if (this.props.isOpen) {
			return;
		}

		if (this.state.isDropdownOpen) this.closeDropdown();
		else this.openDropdown();
	}

	handleNewLockingClick() {
		this.props.newLocking();
		this.closeDropdown();
	}

	handleNewGroupClick() {
		this.props.newGroup();
		this.closeDropdown();
	}

	openDropdown() {
		this.setState({ isDropdownOpen: true });
	}

	closeDropdown() {
		this.setState({ isDropdownOpen: false });
	}
}

function mapStateToProps(state) {
	return {
		isOpen: getLockingForm(state).isOpen
	};
}

function mapDispatchToProps(dispatch) {
	return {
		newLocking: () => {
			dispatch(doOpenLockingForm(LOCKING_FORM_MODES.LOCKING));
		},
		newGroup: () => {
			dispatch(doOpenLockingForm(LOCKING_FORM_MODES.GROUP));
		}
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(LockingsButton);



// WEBPACK FOOTER //
// ./src/js/plan/LockingsButton.js